import { TotpSetupDto } from "../../model/user/dto/TotpSetupDto";
import { TwoFactorConfigDto } from "../../model/user/dto/TwoFactorConfigDto";
import { TwoFactorConfirmEmailDto } from "../../model/user/dto/TwoFactorConfirmEmailDto";
import { TwoFactorConfirmTotpDto } from "../../model/user/dto/TwoFactorConfirmTotpDto";
import { TwoFactorPasswordDto } from "../../model/user/dto/TwoFactorPasswordDto";
import { AtiraApi } from "../AxiosClient";

export class TwoFactorAxios {
  static getConfig() {
    return AtiraApi.get<TwoFactorConfigDto>(`/auth/2fa`).then(
      ({ data }) => data,
    );
  }

  static enableEmail(dto: TwoFactorPasswordDto) {
    return AtiraApi.post<{ pendingVerification: true; devCode?: string }>(
      `/auth/2fa/email/enable`,
      dto,
    ).then(({ data }) => data);
  }

  static confirmEmail(dto: TwoFactorConfirmEmailDto) {
    return AtiraApi.post<TwoFactorConfigDto>(
      `/auth/2fa/email/confirm`,
      dto,
    ).then(({ data }) => data);
  }

  static disableEmail(dto: TwoFactorPasswordDto) {
    return AtiraApi.post<TwoFactorConfigDto>(
      `/auth/2fa/email/disable`,
      dto,
    ).then(({ data }) => data);
  }

  static initTotp(dto: TwoFactorPasswordDto) {
    return AtiraApi.post<TotpSetupDto>(`/auth/2fa/totp/init`, dto).then(
      ({ data }) => data,
    );
  }

  static confirmTotp(dto: TwoFactorConfirmTotpDto) {
    return AtiraApi.post<TwoFactorConfigDto>(
      `/auth/2fa/totp/confirm`,
      dto,
    ).then(({ data }) => data);
  }

  static disableTotp(dto: TwoFactorPasswordDto) {
    return AtiraApi.post<TwoFactorConfigDto>(
      `/auth/2fa/totp/disable`,
      dto,
    ).then(({ data }) => data);
  }

  static disable(dto: TwoFactorPasswordDto) {
    return AtiraApi.post<TwoFactorConfigDto>(`/auth/2fa/disable`, dto).then(
      ({ data }) => data,
    );
  }
}
